<template>
<li id="project_container">
    <div class="right">
        <div class="details_a_logo_container">
            <div class="logo_container"><div class="logo"></div></div>
            <div class="details_a">
                
                <div class="address text_item">
                    <h5>שם הפרויקט</h5>
                    <div>
                        <!-- <span v-for="(bld, i) in item.buildings" :key="bld.id" ><a v-text="bld.address + ' ' + bld.num_street"></a> <span v-if="i+1 < item.numbuildingNum">, </span></span>
                        <span class="city" v-text="' - '+item.city"></span> -->
                        
                        <span v-text="item.name"></span>
                    </div>
                </div>
                <div class="prj_number_item">
                    <h5>מספר פרויקט</h5>
                    <p v-text="item.prj_number"></p>
                </div>
                <div class="building_type_prj_container">
                    <div class="buildings_units_container">
                        <div class="text_item">
                            <div v-text="item.num_building"></div>
                            <h5>בניינים</h5>
                        </div>
                        <div class="text_item">
                            <div v-text="item.num_apartments"></div>
                            <h5>יחידות</h5>
                        </div>
                    </div>
                    <div class="type_prj text_item">
                        <h5>סוג הפרויקט</h5>
                        <div v-text="item.type_parse"></div>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="details_b_status_bar_container">
        <div class="details_b_tag_container">
            <ul class="details_b">
                <li class="text_item">
                    <h5>מועד יצירת המכרז</h5>
                    <div v-text="item.external_data.date_created_parse"></div>
                </li>
                <li class="text_item">
                    <h5>מועד סיום המכרז</h5>
                    <div v-text="item.external_data.date_end"></div>
                </li>
                <li class="text_item">
                    <h5>סוג המכרז</h5>
                    <div v-text="(item.is_open == '1' ? 'פתוח' : 'סגור')"></div>
                </li>
                <li class="text_item">
                    <h5>מס הצעות</h5>
                    <div v-text="item.external_data.num_offers"></div>
                </li>
            </ul>
            
            <div class="tag" :class="{tut: true}" v-if="item.is_active == '0'">
               
                <p >טיוטה</p>

            </div>
        </div>
        <ul class="status_bar">
            <li :class="{selected: +item.status_number === 1}">
                <div class="icon_container"><div class="icon"></div></div>
                <span class="text">בהכנה</span>
            </li>
            <li :class="{selected: +item.status_number === 2}">
                <div class="icon_container"><div class="icon"></div></div>
                <span class="text">קבלת הצעות</span>
            </li>
            <li :class="{selected: +item.status_number === 3}">
                <div class="icon_container"><div class="icon"></div></div>
                <span class="text">נסגר</span>
            </li>
            <li :class="{selected: +item.status_number === 4}">
                <div class="icon_container"><div class="icon"></div></div>
                <span class="text">שקלול הצעות</span>
            </li>
            <li :class="{selected: +item.status_number === 5}">
                <div class="icon_container"><div class="icon"></div></div>
                <span class="text">הסתיים</span>
            </li>
        </ul>
    </div>
    <ul class="actions">
        <li v-tooltip.left="'שכפול מכרז'" @click="duplicatePro(item.id)" class="duplicate"><div  class="icon"></div></li>
        <li v-tooltip.left="'שיתוף'" class="share"><a target="_blank" :href="item.share_link" class="icon"></a></li>
        <li v-tooltip.left="'פירוט הצעות'" class="change_status"><a :href="item.offers_link" class="icon"></a></li>
        <li v-tooltip.left="'ברגע שיש הצעה למכרז לא ניתן לערוך'" class="edit"  :class="{disable: /* +item.external_data.num_offers > 0 */ false}"
            ><a :href="/* (!+item.external_data.num_offers > 0) ? */ item.edit_link /* : '' */" class="icon"></a></li>
        <li v-tooltip.left="'מחיקת מכרז'" @click="deletePro(item.id)" class="delete"><div  class="icon"></div></li>
    </ul>
</li>
</template>

<script>
export default {
    props: ["item"],
    methods: {
        deletePro(id) {
            this.confirm(this.get_word('delete_project'), this.get_word('ok_delete'),this.get_word('cancel_delete')).then((result) => {
            if (result) {
               this.$emit('deleteProject', id)
            }
            });
            
        },
        duplicatePro(id) {
            this.confirm("האם אתה בטוח שברצונך לשכפל את המכרז?", "כן","לא").then((result) => {
                if (result) {
                    this.$emit('duplicateProject', id)
                }
            });
        }

    }
}
</script>

<style lang="scss" scoped>
#project_container {display: flex;border-radius: 40px; background: #fff;border: 1px solid transparent;
    
    &:hover { border: 1px solid var(--text_s);
        .actions {  gap: 8px;
            li {width: 34px; height: 34px; background: #E4E4E7; padding: 8px;
                &.disable { background: var(--gray); cursor: default;
                    a { pointer-events: none;}
                }
                .icon { width: 100%; height: 100%; display: block; background-size: contain; background-repeat: no-repeat; background-position: center center; }
                &.share .icon {background-image: url(../assets/share.svg);}
                &.change_status .icon {background-image: url(../assets/stages.svg);}
                &.edit .icon {background-image: url(../assets/edit.svg);}
                &.delete .icon {background-image: url(../assets/trash.svg);}
                &.duplicate .icon {background-image: url(../assets/copy.svg);}
            }
        }
    }
    .text_item { display: flex; flex-direction: column; gap: 10px; line-height: 1;
        h5 {font-size: var(--h5); color: var(--dark_blue); font-weight: 500;}
        div {font-size: var(--h5); color: var(--dark_blue); font-weight: 700;}
    }
    .right { flex: 3; padding: 8px;
        .details_a_logo_container { height: 100%; width: 100%; padding: 30px; display: flex; gap: 16px; border-radius: 32px; border: 1px solid var(--pageBG); background: var(--gray); 
            .logo_container { width: 40px; height: 40px; padding: 8px; background: var(--dark_blue); border-radius: 100%;
                .logo {background-position: center center; background-size: contain; background-repeat: no-repeat; background-image: url(../assets/building.svg); width: 100%; height: 100%;}
            }
            .details_a { display: flex; flex-direction: column; justify-content: space-between;
                .address {}
                .prj_number_item { display: flex; gap: 10px;    align-items: center;
                    h5 { color: var(--dark_blue);}
                    p { color: var(--text_s); font-size: var(--h6); line-height: 1;}
                }

                .building_type_prj_container { display: flex; flex-direction: column; gap: 10px;
                    .buildings_units_container { display: flex; gap: 15px;
                        >div {display: flex; flex-direction: row; align-items: center; gap: 5px;}
                    }
                    .type_prj {display: flex; flex-direction: row; gap: 5px; 
                        div {font-weight: 400;}
                        h5  { color: var(--text_s);}
                        div, h5 { font-weight: 500;}
                    }
                }

            }
        }
    }
    .details_b_status_bar_container { flex: 7; display: flex; flex-direction: column; gap: 56px; padding: 30px;
        @include mobile {padding: 18px;}
        .details_b_tag_container { display: flex; padding-right: 55px; gap: var(--gap);
            .details_b {display: flex; gap: 40px; 
                 @include mobile {
                     gap: 10px;flex-direction: column;
                }
                .text_item {
                    h5 { color: var(--text_s);}
                }
            }
            
        }
        
    }
    .actions { display: flex; flex-direction: column; width: 80px; border-right: 1px solid var(--pageBG);
        @include mobile {flex-direction: row;width: 100%;height: 60px;}
        display: flex; align-items: center; justify-content: center; gap: 16px; 
        li { cursor: pointer; width: 4px; height: 4px; background: #E4E4E7;  border-radius: 50%;
            .icon {display: none;}
        }
    }
    // .prj_data_container {
    //     li { display: flex; flex-direction: column; gap: 10px;
    //         h5 {color: #8E8E8E;}
    //         >div {color: #333;}
    //     }
    // }
    // .right { border-left: 1px #333 solid; width: 250px;
    //     --local_gap: 15px;
    //     ul {  display: flex; flex-wrap: wrap; gap: var(--local_gap);
    //         li {flex-basis: calc(50% - var(--local_gap)); max-width: calc(50% - var(--local_gap));}
    //     }
    // }
    // .details { flex: 1; display: flex; flex-direction: column; gap: 30px;  padding: 20px; position: relative;
    //     .status { display: flex; flex-direction: column;
    //         h4 {}
    //         ul {
    //             li {display: flex; align-items: center; flex-direction: row;
    //                 &::after{ content: '---'; display: block;}
    //                 &:last-child {
    //                     &::after {display: none;}
    //                 }
    //                 & { color: #999;
    //                     i, svg {font-size: 22px;}
    //                 }
                    
    //                 &.selected ~ li, &.selected { color: #333;
    //                     .icon { border-radius: 50%; border: #333 1px solid; width: 13px; height: 13px;
    //                         i, svg {display: none;}
    //                     }
    //                 }
    //                 &.selected {
    //                     font-weight: 600;
    //                 }
                    
    //             }
    //         }

    //     }
    // }
    // .tag_actions { padding: 20px; display: flex; flex-direction: column; justify-content: space-between;
    //     .tag {background: #F5F5F5; display: flex; gap: 5px; border-radius: 25px; padding: 7px 25px;
    //         .num {color: #333; font-weight: 600;}
    //         .msg {color: #333; white-space: nowrap;}
    //     }
    //     .actions_btns { transition: 0.2s all ease; opacity: 0; display: flex; justify-content: center; gap: 10px;
    //         >div { cursor: pointer; display: flex; align-items: center; justify-content: center; width: 30px; height: 30px; border-radius: 50%; background: #eee;
    //             &:hover {background: #ddd;}
    //             i, svg {font-size: 15px;}
    //         }
    //     }
    // }
    @include mobile {
        flex-direction: column;
         border: 1px solid var(--text_s);
            .actions {  gap: 8px;
                li {width: 34px; height: 34px; background: #E4E4E7; padding: 8px;
                    &.disable { background: var(--gray); cursor: default;
                        a { pointer-events: none;}
                    }
                    .icon { width: 100%; height: 100%; display: block; background-size: contain; background-repeat: no-repeat; background-position: center center; }
                    &.share .icon {background-image: url(../assets/share.svg);}
                    &.change_status .icon {background-image: url(../assets/stages.svg);}
                    &.edit .icon {background-image: url(../assets/edit.svg);}
                    &.delete .icon {background-image: url(../assets/trash.svg);}
                    &.duplicate .icon {background-image: url(../assets/copy.svg);}
                }
            }
        
    }
}
</style>